module.exports = __webpack_public_path__ + "img/sign-up-img-2@x2.37888e9.png";